<dx-popup
    #transferHistoryBox
    width="50%"
    height="40%"
    [title]="popUpTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="ar-payment-transfer-history-content">
        <dx-data-grid
            width="100%"
            height="100%"
            [dataSource]="arPaymentTransferHistory"
            [allowColumnReordering]="true"
            [allowColumnResizing]="true"
            [columnAutoWidth]="true"
            [showBorders]="true"
            [showColumnLines]="true"
            [showRowLines]="true"
            noDataText="No data to display"
        >
            <dxi-column dataField="user" caption="User" dataType="string" cellTemplate="userBioTemplate"></dxi-column>
            <dxi-column dataField="actionedOn" caption="Date" dataType="date" [format]="dateTimeFormat"></dxi-column>
            <dxi-column dataField="message" caption="Additional Information" dataType="string"></dxi-column>
            <div *dxTemplate="let row of 'userBioTemplate'">
                <app-user-bio-link
                    [user]="row.data.updatedBy"
                    [communityId]="arPaymentParam?.communityId"
                ></app-user-bio-link>
            </div>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
            <dxo-group-panel [visible]="false"></dxo-group-panel>
            <dxo-sorting mode="none"></dxo-sorting>
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
        </dx-data-grid>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#transferHistoryBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
